import { render, staticRenderFns } from "./PayTitle.vue?vue&type=template&id=04114724&scoped=true&"
import script from "./PayTitle.vue?vue&type=script&lang=js&"
export * from "./PayTitle.vue?vue&type=script&lang=js&"
import style0 from "./PayTitle.vue?vue&type=style&index=0&id=04114724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04114724",
  null
  
)

export default component.exports